<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = title)"></div>

    <van-swipe indicator-color="white" class="bannerSwiper">
      <van-swipe-item v-for="(item, index) in info.ImgList" :key="index">
        <van-image fit="cover" :src="item" />
      </van-swipe-item>
    </van-swipe>

    <div class="infoBox">
      <div class="logo">
        <van-image
          :src="info.Photo"
          fit="contain"
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        />
      </div>
      <div class="content">
        <div class="name">{{ info.Headline }}</div>
        <div class="overFlowTwo">{{ info.HeadlineIntroduction }}</div>
        <div class="tips" v-if="info.IsExhibition">
          2026光亚展参展商 {{ info.HallNo }}馆 {{ info.PlaceNo }}
        </div>
      </div>
    </div>

    <div class="functionBox">
      <div class="funcItem" @click.stop="toItemHandle(0)">
        <img src="../../../static/images/storeIcon/icon_shop_02.png" />
        <div class="funcName">产品展示</div>
      </div>
      <div class="funcItem" v-if="hasMini" @click.stop="toItemHandle(1)">
        <img src="../../../static/images/storeIcon/icon_shop_03.png" />
        <div class="funcName">企业名片</div>
      </div>
      <div class="funcItem" v-else @click.stop="toItemHandle(2)">
        <img src="../../../static/images/storeIcon/icon_shop_04.png" />
        <div class="funcName">企业视频</div>
      </div>
      <div class="funcItem" @click.stop="toItemHandle(3)">
        <img
          src="../../../static/images/storeIcon/icon_shop_06.png"
          style="width: 25px; height: 25px; margin-top: 5px"
        />
        <div class="funcName" style="margin-top: 8px">文章</div>
      </div>
      <div class="funcItem contactFiex">
        <transition name="slide-left">
          <div class="contactBox" v-if="!cardShow" @click.stop="openCard()">
            <img src="../../../static/images/storeIcon/icon_shop_05.png" />
            <div class="funcName">联系我</div>
          </div>
        </transition>
        <transition name="slide-right">>
          <div class="card" v-if="cardShow">
            <img
              src="../../../static/images/storeIcon/img_cardbg.jpg"
              class="cardbgImg"
            />
            <img
              src="../../../static/images/storeIcon/icon_zoom.png"
              class="closeImg"
              @click.prevent="cardShow = false"
            />
            <div class="card_top">
              <img :src="businessInfo.Photo" class="avatarImg" />
              <div>
                <div class="name">{{ businessInfo.ContactName }}</div>
                <span>{{ businessInfo.Duty }}</span>
              </div>
            </div>
            <div class="card_btm">
              <div class="wechat">
                <img :src="businessInfo.WeiXinQRCode" />
                <div>微信号</div>
                <div>{{ businessInfo.WeiXin }}</div>
                <div class="copy" @click="copyClick">复制</div>
              </div>
              <div class="detail">
                <div class="detailItem">手机：{{ businessInfo.Mobile }}</div>
                <div class="detailItem">邮箱：{{ businessInfo.Email }}</div>
                <div class="detailItem">地址：{{ businessInfo.Address }}</div>
                <div class="operate">
                  <div class="operateItem">
                    <img
                      src="../../../static/images/storeIcon/icon_shop_17.png"
                    />
                    <div>
                      <a
                        style="color: #666"
                        :href="'tel:' + businessInfo.Mobile"
                        >打电话</a
                      >
                    </div>
                  </div>
                  <div class="operateItem">
                    <img
                      src="../../../static/images/storeIcon/icon_shop_16.png"
                    />
                    <div>
                      <a
                        style="color: #666"
                        :href="'tel:' + businessInfo.Mobile"
                        >存名片</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="recommendBox">
      <div class="title">推荐产品</div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getProductList"
      >
        <div class="recommendList">
          <div
            v-for="(item, index) in list"
            :key="index"
            @click="toProDetail(item.GoodsId)"
            class="recommendItem"
          >
            <img :src="item.Thumbnail" />
            <div class="goodsName overFlowTwo">{{ item.GoodsName }}</div>
          </div>
        </div>
      </van-list>
    </div>

    <div class="footerSBox">
      <div class="footItem" @click="tabHandle(1)">
        <img
          src="../../../static/images/tabBar/menu1_on.png"
          class="homeIcon"
          v-if="active == 1"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu1_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">首页</div>
      </div>
      <div class="footItem" @click="tabHandle(2)">
        <img
          src="../../../static/images/tabBar/menu2_on.png"
          class="homeIcon"
          v-if="active == 2"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu2_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">产品</div>
      </div>
      <div class="footItem" @click="tabHandle(3)">
        <img
          src="../../../static/images/tabBar/menu3_on.png"
          class="homeIcon"
          v-if="active == 3"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu3_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">公司介绍</div>
      </div>
      <div class="footItem" @click="tabHandle(4)">
        <img
          src="../../../static/images/tabBar/menu4_on.png"
          class="homeIcon"
          v-if="active == 4"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu4_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">联系</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getShareData } from "@/utils/share";
import { companyDetail } from "@/api/store";
import { productList } from "@/api/product";
import { Swipe, SwipeItem, List, Image } from "vant";

export default {
  name: "storeshow",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      mid: 0,
      offsetTop: 1100,
      tabFixed: false,
      info: {},
      hasMini: false,
      cardShow: false, //名片弹窗

      //名片信息
      businessInfo: {},

      list: [], //商品列表
      pageIndex: 1,
      total: 0,
      loading: false,
      finished: false,
      error: false,

      title: "", //分享标题
      active: 1, //底部tab
    };
  },
  watch: {
    screenHeight(val) {
      if (this.originHeight > val + 100) {
        //加100为了兼容华为的返回键
        this.isOriginHeight = false;
      } else {
        this.isOriginHeight = true;
      }
    },
  },

  methods: {
    //tab切换
    tabHandle(type) {
      if (type == 1) {
        this.active = 1;
        this.$router.push({
          path: "/storeShow",
          query: { mid: this.mid },
        });
      } else if (type == 2) {
        this.active = 2;
        this.$router.push({
          path: "/product",
          query: { mid: this.mid },
        });
      } else if (type == 3) {
        this.active = 3;
        this.$router.push({
          path: "/companyIntro",
          query: { mid: this.mid },
        });
      } else if (type == 4) {
        this.active = 4;
        this.$router.push({
          path: "/contact",
          query: { mid: this.mid },
        });
      } else { }
    },

    //获取头条号
    getInfo() {
      var that = this;
      var data = {
        MemberId: that.mid,
        BusinessMemberId: 0,
      };
      companyDetail(data).then((res) => {
        that.info = res.Data;
        that.businessInfo = res.Data.BusinessContactModel;
        that.title = res.Data.Headline;
        sessionStorage.setItem("title", res.Data.Headline);
        getShareData(
          window.location.href,
          res.Data.Headline,
          res.Data.HeadlineIntroduction,
          res.Data.Photo
        );
      });
    },

    //获取商品列表
    getProductList() {
      var that = this;
      var data = {
        CategoryId: 0,
        Keyword: "",
        Page: {
          PageSize: 10,
          PageIndex: that.pageIndex,
        },
        IsRecommend: true,
        MemberId: that.mid,
        IsCustomCategory: that.isCustomCategory,
      };
      productList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },

    //复制微信号
    copyClick() {
      if (this.businessInfo.WeiXin) {
        this.$copyText(this.businessInfo.WeiXin).then(
          (e) => {
            this.$toast.success("复制成功");
          },
          (e) => {
            this.$toast.fail("复制失败");
          }
        );
      } else {
        this.$toast("没有微信号！");
      }
    },

    //点击联系打开名片
    openCard() {
      if (this.businessInfo) {
        this.cardShow = true;
      } else {
        this.$toast("该企业为设置业务联系人");
      }
    },

    //商品详情
    toProDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { id: id },
      });
    },

    //跳转
    toItemHandle(n) {
      if (n == 0) {
        this.$router.push({
          path: "/product",
          query: { mid: this.mid },
        });
      } else if (n == 1) {
      } else if (n == 2) {
        this.$router.push({
          path: "/videoList",
          query: { mid: this.mid },
        });
      } else if (n == 3) {
        this.$router.push({
          path: "/articleList",
          query: { mid: this.mid },
        });
      } else { }
    }
  },

  mounted() {
    this.mid = this.$route.query.mid || Number(this.$route.params.mid);
    this.getInfo();
  }
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 50px;
  background-color: #f7f4f8;
  .bannerSwiper {
    width: 100%;
    height: 200px;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    .van-image {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .infoBox {
    background: #fff;
    display: flex;
    padding: 13px;
    margin-bottom: 14px;
    .logo {
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      .van-image {
        display: block;
        width: 60px;
        height: 60px;
        border: 1px solid #eee;
      }
    }
    .content {
      color: #999;
      font-size: 10px;
      width: 260px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-left: 10px;
      .name {
        font-weight: bold;
        font-size: 14px;
        line-height: 18px;
        color: #333;
      }
      .tips {
        color: #ad913c;
      }
      div {
        &:first-child {
          font-weight: bold;
          font-size: 12px;
          line-height: 14px;
          color: #333;
        }
      }
    }
  }
  .functionBox {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .funcItem {
      width: 80px;
      height: 80px;
      background: rgba(255, 255, 255, 1);
      border-radius: 3px;
      font-size: 12px;
      color: #666;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      .funcName {
        margin-top: 3px;
      }
      &:first-child {
        margin-left: 14px;
      }
      img {
        width: 35px;
        height: 35px;
      }
      .contactBox {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #ffffff;
      }
      .card {
        position: absolute;
        z-index: 1111;
        width: 350px;
        height: 245px;
        top: 0;
        right: 0px;
        box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.21);
        border-radius: 3px;
        overflow: hidden;
        padding-top: 26px;
        box-sizing: border-box;
        .cardbgImg {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: -1;
          top: 0;
          left: 0;
        }
        .closeImg {
          position: absolute;
          width: 22px;
          height: 22px;
          top: 12px;
          right: 15px;
        }
        .card_top {
          display: flex;
          align-items: center;
          .avatarImg {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 29px;
            margin-left: 33px;
          }
          div {
            color: #666;
            font-size: 11px;
          }
          .name {
            color: #333;
            font-size: 19px;
            font-weight: bold;
            margin-bottom: 5px;
          }
        }
        .card_btm {
          display: flex;
          margin-top: 22px;
          .wechat {
            width: 68px;
            color: rgb(85, 84, 84);
            font-size: 11px;
            text-align: center;
            margin-right: 27px;
            margin-left: 17px;
            img {
              width: 52px;
              height: 52px;
              vertical-align: top;
              margin-bottom: 2px;
            }
            div {
              line-height: 14px;
            }
            .copy {
              color: #2268e8;
              margin-top: 8px;
            }
          }
          .detail {
            color: #333;
            font-size: 12px;
            .detailItem {
              font-size: 12px;
              margin-top: 8px;
              &:first-child {
                margin-top: 0;
              }
            }
            .operate {
              margin-top: 22px;
              display: flex;
              .operateItem {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100px;
                height: 30px;
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 5px;
                font-size: 13px;
                color: #666;
                &:first-child {
                  margin-right: 12px;
                }
                img {
                  width: 25px;
                  height: 25px;
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }
    }
    .contactFiex {
      position: relative;
      right: 0;
      top: 0;
      background: transparent;
    }
  }
  .recommendBox {
    .title {
      font-size: 13px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      padding: 0 16px;
      margin-bottom: 25px;
      text-align: center;
    }
    .recommendList {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 0 12px;
      justify-content: space-between;
      box-sizing: border-box;
      .recommendItem {
        background: #fff;
        width: 170px;
        box-shadow: 0px 1px 21px 0px rgba(0, 0, 0, 0.08);
        border-radius: 3px;
        overflow: hidden;
        margin-bottom: 16px;
        padding: 20px 5px;
        box-sizing: border-box;
        text-align: center;
        img {
          width: 100%;
          height: 150px;
          display: block;
          border-radius: 3px 3px 0 0;
        }
      }
      .goodsName {
        font-size: 12px;
        color: #333;
        padding: 14px 3px 0 3px;
        line-height: 15px;
        text-align: center;
      }
    }
  }
}
/* 左边进入 */
.slide-left-enter,
.slide-left-leave-active {
  transform: translateX(-375px);
}

.slide-left-leave-active,
.slide-left-enter-active {
  transition: all 0.5s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}

/* 右边进入 */
.slide-right-enter,
.slide-right-leave-active {
  transform: translateX(375px);
}

.slide-right-leave-active,
.slide-right-enter-active {
  transition: all 0.5s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
</style>